import React, { useEffect, useRef } from 'react';
import './ConfirmDialog.css';

// A small modal for confirming an action, instead of window.confirm (which
// blocks the page). Escape or the backdrop cancels; Tab stays inside it.
const ConfirmDialog = ({ title, children, confirmLabel = 'Confirm', busy = false, onConfirm, onCancel }) => {
  const dialogRef = useRef(null);
  const confirmRef = useRef(null);

  useEffect(() => {
    const previous = document.activeElement;
    confirmRef.current?.focus();
    return () => { if (previous && previous.focus) previous.focus(); };
  }, []);

  const onKeyDown = (e) => {
    if (e.key === 'Escape' && !busy) { e.stopPropagation(); onCancel(); return; }
    if (e.key !== 'Tab') return;
    const buttons = [...dialogRef.current.querySelectorAll('button:not([disabled])')];
    if (buttons.length === 0) return;
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  return (
    <div className="confirm-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onCancel(); }}>
      <div
        ref={dialogRef}
        className="confirm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onKeyDown={onKeyDown}
      >
        <h2 id="confirm-dialog-title" className="confirm-title">{title}</h2>
        <div className="confirm-body">{children}</div>
        <div className="confirm-actions">
          <button type="button" className="text-button" onClick={onCancel} disabled={busy}>Cancel</button>
          <button ref={confirmRef} type="button" className="title-button" onClick={onConfirm} disabled={busy}>
            {busy ? 'Saving…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
